import { IWorkspaceModule } from '../context/context.interface';

const moduleAlreadyExists = (moduleName: string, data: IWorkspaceModule[]) => data.some((item) => item.moduleKeyName === moduleName);

const isSwitchField = (field: string) => {
    const switchFields = ['canAssignDriversOnBatch', 'showMetricSection'];
    return switchFields.includes(field);
};

export { isSwitchField, moduleAlreadyExists };
